<template>
  <div class="Location">
        <p class="location-title">地理位置:</p>
        <div class="location-content">
            <p :class="{'active':searcValue.district==''&&searcValue.lon_lat==''&&searcValue.cityType==''}" @click="cityTab()">不限</p>
            <ul class="location-list">
                <li v-for="(item,index) in titleList" :key="index" @click="cityTab(item.type)" :class="{'active':searcValue.cityType==item.type}">{{item.name}}<i class="el-icon-arrow-down"></i></li>
            </ul>
            <!--商圈景点大学信息-->
            <div  class="brand-list" v-if="searcValue.cityType>0">
                <div  class="brand-list-lst">
                    <span class="brand-list-lst-span"></span>
                    <ul class="brand-list-lst-ul">
                        <li  @click="clickItem(item)" v-for="item in blocks()" :key="item.name" :class="{'active':searcValue.lon_latName==item.landmark||searcValue.district==item.id}">{{item.landmark||item.title}}</li>
                    </ul>
                </div>
            </div>
        </div>
  </div>
</template>

<script>

import LocationData from '@/assets/utils/LocationData.json'   //城市的商圈景点等位置信息
import provinces from '@/assets/utils/provinces'           //省份信息
export default {
  name: '',
  components: {},
  props: {
    searcValue: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        titleList:[{name:'行政区域',type:'1'},{name:'商业中心',type:'4'},{name:'热门景点',type:'5'},{name:'大学周边',type:'7'}],
        tabindex:'',
    };
  },
  computed: {},
  watch: {
  },
  created() {},
  mounted() {},
  methods: {
        //切换城市信息
        cityTab(index){
            this.$emit('inform', [{key:'cityType',date:index},{key:'district',date:''},{key:'lon_lat',date:''}]);
        },
        /*获取区域信息*/
        getBlocks(item) {
            this.blocks = [];         //每次重新获取区域前，清空上次已选区域
            this.LocationPoint = '';  //每次重新获取区域前，清空上次已选商圈景点大学信息
            if (this.cityFlag.id === 0) {
            this.UPDATEBLOCKLIST();
            return;
            }
            this.GetCityBlocks({
            city: item
            })
        },
        //获取城市信息
        blocks(){
            let Arr = [];   
            if(this.searcValue.cityType == '1'){
                Arr = provinces.filter(item => item.up == this.searcValue.cityId);
            }else{
                Arr = LocationData[this.searcValue.cityId] ? LocationData[this.searcValue.cityId][this.searcValue.cityType] : [];
            }
            return Arr||[];
        },
        //点击地区信息
        clickItem(item){
            //区域传ID、或传经纬度
            if(this.searcValue.cityType == '1'){
                this.$emit('inform', [{key:'district',date:item.id},{key:'lon_lat',date:''}]);

            }else{
                this.$emit('inform', [{key:'lon_lat',date:item.lng_lat},{key:'lon_latName',date:item.landmark},{key:'district',date:''}]);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .Location{
        display: flex;
    }
    .location-title{
        margin-right: 20px;
        width: 8%;
        line-height: 26px;
        text-align: left;
        font-size: 13px;
    }
    .location-content{
        display: flex;
        flex-wrap: wrap;
        width: 92%;
    }
    .location-content p,.location-list li{
        background-color: #f1f2f4;
        display: inline-block;
        padding: 0 10px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;
    }
    .location-list{
        display: flex;
    }
    .location-list li i{
        margin-inline-start: 4px;
        color: #666;
    }
    .location-list li{
        cursor: pointer;
    }
    .location-list i{
        transition: transform 0.3s ease; /* 平滑旋转 */
    }
    /* 旋转90度（向右） */
    .location-list .active i{
            transform: rotate(180deg);
    }
    .location-list li:not(.active):hover{
        background-color: #e5e7eb;
    }  
    .location-content .active{
        background-color: var(--smtc-color-primary);
        color: #fff;
    }
    .location-content .active .el-icon-arrow-down{
        color: #fff;
    }
    //-----------------------------------
    //酒店品牌
    //-----------------------------------
    .brand-list{
        width: 100%;
    }
    .brand-list-lst{
        width: 100%;
        display: flex;
    }
    .brand-list-lst-span{
        width: 4%;
        margin-right: 22px;
        margin-top: 17px;
        font-size: 12px;
    }
    .brand-list-lst-ul{
        display: flex;
        flex-wrap: wrap;
        width: 92%;
        font-size: 12px;
    }
    .brand-list-lst-ul li{
        background-color: #f1f2f4;
        display: inline-block;
        padding: 0 10px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 16px;
        cursor: pointer;
        margin-top: 10px;
    } 
</style>
